/**
 * Vercel Analytics and Speed Insights initialization
 * 
 * This module initializes Vercel's Web Analytics and Speed Insights
 * for tracking user interactions and performance metrics.
 */

import { inject } from '@vercel/analytics'
import { injectSpeedInsights } from '@vercel/speed-insights'

/**
 * Initialize Vercel Analytics and Speed Insights
 * 
 * Call this function early in the application lifecycle to enable
 * tracking and performance monitoring.
 */
export function initializeAnalytics(): void {
    // Initialize Vercel Web Analytics
    inject()

    // Initialize Vercel Speed Insights
    injectSpeedInsights()

    console.log('Vercel Analytics and Speed Insights initialized')
}